export default __webpack_public_path__ + "static/media/i_bus-tro_bl_tagless.1abbedc0.svg";